import React, { useEffect, useState } from "react";
import { fileUrl } from "../lib/api";
import api from "../lib/api";

/**
 * Renders a photo from Emergent Object Storage.
 * Uses blob-fetch pattern so we can pass Authorization header
 * (the query-param auth also works via /api/files?path=...&auth=token).
 */
export default function ReportPhoto({ path, className = "", alt = "foto" }) {
  const [url, setUrl] = useState(null);
  const [err, setErr] = useState(false);

  useEffect(() => {
    if (!path) return;
    let revoke = null;
    api.get(`/files?path=${encodeURIComponent(path)}`, { responseType: "blob" })
      .then(r => {
        const u = URL.createObjectURL(r.data);
        revoke = u;
        setUrl(u);
      })
      .catch(() => setErr(true));
    return () => { if (revoke) URL.revokeObjectURL(revoke); };
  }, [path]);

  if (err) return <div className={`bg-neutral-100 text-xs text-neutral-500 grid place-items-center rounded ${className}`}>Foto no disponible</div>;
  if (!url) return <div className={`bg-neutral-100 animate-pulse rounded ${className}`} />;
  return <img src={url} alt={alt} className={`object-cover rounded ${className}`} data-testid="report-photo" />;
}
